export default "__VITE_PUBLIC_ASSET__a70763d8__"